import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "antd";

import ModalViewer from "../Modals/ModalViewer";

const DownloadAnexo = ({ docGerado, nomeDocGerado, setDocGerado, setFileList, temViewer, temExcluir }) => {
    const [docs, setDocs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);

    const download = async () => {
        try {
            const response = await fetch(docGerado);
            if (!response.ok) throw new Error("Erro ao buscar o PDF");

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", nomeDocGerado);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Erro ao fazer download do PDF:", error);
        }
    };

    const abrirViewer = () => {
        setDocs([{ uri: docGerado, fileName: nomeDocGerado }]);
        setModalVisible(true);
    };

    const excluir = () => {
        setFileList([]);
        setDocGerado("");
    };

    return (
        <>
            <div className="bloco">
                <div className="lista-videos">
                    <div className="item-video">
                        <span className="video-titulo">{nomeDocGerado}</span>
                        <div className="video-controlos">
                            <Link to="#" className="botao-icon-download" title="Descarregar" onClick={download}>
                                <Icon type="download" />
                            </Link>
                            {temViewer && (
                                <Link to="#" className="botao-icon-detalhe" title="Descarregar" onClick={abrirViewer}>
                                    <Icon type="eye" />
                                </Link>
                            )}
                            {temExcluir && (
                                <Link to="#" className="botao-icon-excluir" title="Excluir" onClick={excluir}>
                                    <Icon type="delete" />
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
};

export default DownloadAnexo;
